/** biome-ignore-all lint/style/useNamingConvention: endpoints expect snake case */
import urls from 'urls';
import {api} from '~/ViewInvitation/api/api';
import {
  type GuestQueryArgs,
  type GuestResponse,
  type MutateGuestQueryArgs,
  type MutateResponse,
  type UpdateGuestQueryArgs,
} from '~/ViewInvitation/types/api';

export const guestsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // take note that `guestId` is the current user
    getGuests: builder.query<GuestResponse, GuestQueryArgs>({
      query: ({eventId, guestId}) => ({
        url: `/services/event/v2/${eventId}/guests${guestId ? `?gid=${guestId}` : ''}`,
      }),
      providesTags: ['Guests'],
    }),
    // whereas the rest of these `guestId`s are the guests being updated
    updateGuest: builder.mutation<MutateResponse, MutateGuestQueryArgs>({
      query: ({userId, eventId, guest}) => {
        const url = urls.get('ajax_update_guest', {
          event_id: eventId,
          guest_id: userId,
        });

        return {
          url,
          body: {...guest, user_id: userId},
          method: 'PATCH',
        };
      },
      invalidatesTags: ['Guests'],
    }),
    deleteGuest: builder.mutation<MutateResponse, UpdateGuestQueryArgs>({
      query: ({userId, eventId}) => {
        const url = urls.get('ajax_update_guest', {
          event_id: eventId,
          guest_id: userId,
        });

        return {
          url,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['Guests'],
    }),
  }),
});

export const {useGetGuestsQuery, useUpdateGuestMutation, useDeleteGuestMutation} = guestsApi;
